// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__ggE5C","text":"styles_text__1F_Jq","fadeInOut":"styles_fadeInOut__Z6PVS","loader":"styles_loader___HwKQ"};